import { defineNuxtPlugin, useHead, useRuntimeConfig } from '#app'

export default defineNuxtPlugin(() => {
  const { public: pub } = useRuntimeConfig()

  const src = 'https://cdn.consentmanager.net/delivery/js/semiautomatic.min.js'

  if (import.meta.client) {
    useHead({
      script: [
        {
          type: 'text/javascript',
          src,
          tagPosition: 'bodyClose',
          tagPriority: 'high',
          async: true,
          'data-cmp-ab': '1',
          'data-cmp-host': 'a.delivery.consentmanager.net',
          'data-cmp-cdn': 'cdn.consentmanager.net',
          'data-cmp-codesrc': '0',
          'data-cmp-cdid': pub.consentManager?.cdid,
        },
      ],
    })
  }
})
